import { svgIconPaths, svgIcons } from '@/assets/svg/icons';
import CustomButton from '@/components/atoms/CustomButton';
import ModalContainer from '@/components/molecules/ModalContainer/ModalContainer';
import colors from '@/theme/colors';
import { TMemberCareMember } from '@/types/MemberCare.types';
import { getAgeFromBirthDay } from '@/utils/stringUtils';
import { Center, HStack, Image, Text, useDisclosure, VStack } from '@chakra-ui/react';
import React from 'react';

const IMAGE_SIZE_PX = '80px';

type Props = {
  member: TMemberCareMember;
};

const MemberInfoHeader = ({ member }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <HStack justify={'space-between'} width={'100%'} marginBottom={'60px'}>
      {/* User photo and info */}
      <HStack gap={'20px'}>
        <Image
          src={member.profilePicture || svgIcons.genericUser}
          width={IMAGE_SIZE_PX}
          height={IMAGE_SIZE_PX}
          alt="member-profile-photo"
          borderRadius={'50%'}
          objectFit={'cover'}
        />
        <VStack gap={'2px'} alignItems={'flex-start'}>
          <Text variant="loraSmallTitle" fontWeight={'500'}>
            {member.firstName} {member.lastName}
          </Text>
          <Text variant={'urbanistSemiBold'} color={'text.mediumGray'}>
            {member.orgName || member.organizationName}
          </Text>
          <Text variant={'urbanistSemiBold'} color={'text.mediumGray'}>
            {member.dateOfBirth &&
              getAgeFromBirthDay(member.dateOfBirth) > 0 &&
              `${getAgeFromBirthDay(member.dateOfBirth)} years old`}{' '}
            {member.sex}
          </Text>
        </VStack>
      </HStack>
      {/* Chat and Phone buttons */}
      <HStack gap={8}>
        {/* <CustomButton
                onClick={() => {}} // TODO: Example nav  ->  navigate({ to: '/something/$somethingId', params: { somethingId: 'id-of-something' } })
                isTransparent
                label="Chat"
                labelColor={colors.text.darkBlue}
                iconBeforeLabelSvgPath={svgIconPaths.message}
                iconBeforeLabelSvgColor={colors.text.darkBlue}
                hoverBackgroundColor="extra.white"
                disabled
              /> */}
        <CustomButton
          backgroundColor="primary.500"
          onClick={onOpen}
          label="Phone"
          labelColor={colors.extra.white}
          iconBeforeLabelSvgPath={svgIconPaths.phone}
          iconBeforeLabelSvgColor={colors.extra.white}
        />
      </HStack>
      <ModalContainer isOpen={isOpen} onClose={onClose}>
        <Center marginBottom={'20px'}>
          <Image
            src={member.profilePicture || svgIcons.genericUser}
            width={'150px'}
            height={'150px'}
            alt="member-profile-photo"
            borderRadius={'50%'}
            objectFit={'cover'}
          />
        </Center>
        <VStack marginBottom={'30px'}>
          {member.phone ? (
            <VStack gap={0} marginY={'10px'}>
              <Text variant={'loraSmallTitle'} color={'primary.blueGray'}>
                Phone Number:{' '}
                <a style={{ color: colors.primary[500], fontWeight: 500 }} href={`tel:member.phone`}>
                  {member.phone}
                </a>
              </Text>
              <Text variant={'finePrint'}>Click the number to call</Text>
            </VStack>
          ) : (
            <Text variant={'loraSmallTitle'}>This Member hasn't entered their Phone Number.</Text>
          )}

          <CustomButton
            style={{ margin: '10px 0' }}
            width={'295px'}
            backgroundColor="primary.500"
            onClick={onClose}
            label="Close"
            labelColor={colors.extra.white}
          />
        </VStack>
      </ModalContainer>
    </HStack>
  );
};

export default MemberInfoHeader;
